<section
  class="express-packaging-details"
  [attr.data-package-type-code]="packageTypeCode()"
  data-testid="express-packaging-details"
>
  @if (isEnvelope()) {
    <app-alert-toast
      class="express-packaging-details__disclaimer"
      severity="warning"
      live="polite"
      [message]="
        'createShipment.packageStep.types.expressEnvelope.overWeightDisclaimer' | translate
      "
    />
  } @else if (isPack() || isBox()) {
    @if (hasWeightError()) {
      <app-alert-toast
        class="express-packaging-details__weight-error"
        severity="error"
        live="assertive"
        [message]="weightErrorKey() | translate: weightErrorParams()"
      />
    }

    <div class="express-packaging-details__weight-field">
      <!-- Remount when Pack/Box type changes so setValue(1) is visible in puro-input. -->
      @for (code of [packageTypeCode()]; track code) {
        <puro-input
          class="express-packaging-details__weight-input"
          [label]="'createShipment.packageStep.express.totalWeight' | translate"
          type="text"
          labelPosition="floating"
          appPackageMeasureInput
          [required]="true"
          [endAdornment]="true"
          [formControl]="expressTotalWeight()"
          (focusout)="onWeightBlur()"
        >
          <span endAdornment class="express-packaging-details__unit-adornment">
            <puro-select
              class="express-packaging-details__unit-select"
              [attr.data-testid]="isBox() ? 'express-box-weight-unit' : 'express-pack-weight-unit'"
              [label]="'createShipment.packageStep.express.weightUnitAria' | translate"
              variant="adornment"
              [options]="weightUnitOptions()"
              [value]="weightUnitValue()"
              (valueChange)="onWeightUnitChange($event)"
            />
          </span>
        </puro-input>
      }
    </div>

    @if (isBox() && expressRequiresAdditionalHandling(); as ahControl) {
      <div class="express-packaging-details__additional-handling">
        <puro-checkbox
          class="express-packaging-details__ah-checkbox"
          [formControl]="ahControl"
          [label]="
            'createShipment.packageStep.types.expressBox.additionalHandlingLabel' | translate
          "
        />
        <span class="visually-hidden" id="express-additional-handling-tooltip-desc">{{
          'createShipment.packageStep.types.expressBox.additionalHandlingTooltipStub' | translate
        }}</span>
        <puro-tooltip
          #ahTooltip
          [content]="
            'createShipment.packageStep.types.expressBox.additionalHandlingTooltipStub' | translate
          "
        >
          <button
            type="button"
            class="express-packaging-details__ah-info"
            data-testid="express-box-ah-info"
            [attr.aria-label]="
              'createShipment.packageStep.types.expressBox.additionalHandlingInfoAria' | translate
            "
            aria-describedby="express-additional-handling-tooltip-desc"
            (click)="$event.preventDefault(); $event.stopPropagation()"
            (focus)="ahTooltip.show()"
            (blur)="ahTooltip.hide()"
          >
            <puro-icon name="info-circle-tooltip" size="sm" aria-hidden="true" />
          </button>
        </puro-tooltip>
      </div>
    }

    <app-alert-toast
      class="express-packaging-details__disclaimer"
      severity="warning"
      live="polite"
      [message]="
        (isBox()
          ? 'createShipment.packageStep.types.expressBox.overWeightDisclaimer'
          : 'createShipment.packageStep.types.expressPack.overWeightDisclaimer'
        ) | translate
      "
    />
  }
</section>
